import React, {useEffect, useState} from "react";
import Baselining from "./Baselining.page";

function BaseliningSkills() {
    return <Baselining/>
}

export default BaseliningSkills;